export default __webpack_public_path__ + "static/media/08-2.1d85ea87.jpg";